import Interceptor from "@/plugins/interceptor.js";

const urlAPI = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_STUFF}`;

const Stuff = {
  state: {
    teams: [],
    stadiums: [],
    cards: [],
    seasons: [],
    totalCards: ""
  },
  actions: {
    teamsGet: async ({ commit }) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/teamsGet`);
        commit("SET_teams", response.data);
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    teamCreate: async ({}, team) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/teamCreate`, team);
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    teamUpdate: async ({}, team) => {
      try {
        const response = await Interceptor.put(`${urlAPI}/teamUpdate`, team);
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    teamDelete: async ({}, id) => {
      try {
        const response = await Interceptor.put(`${urlAPI}/teamDelete?id=${id}`);
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    getStadiums: async ({ commit }) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getStadiums`);
        commit("SET_stadiums", response.data);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    stadiumCreate: async ({}, stadium) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/stadiumCreate`, stadium);
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    stadiumUpdate: async ({}, stadium) => {
      try {
        const response = await Interceptor.put(`${urlAPI}/stadiumUpdate`, stadium);
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    stadiumDelete: async ({}, id) => {
      try {
        const response = await Interceptor.put(`${urlAPI}/stadiumDelete?id=${id}`);
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    getAvatars: async ({}, teamId) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getAvatars?teamId=${teamId}`);
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    avatarCreate: async ({}, avatar) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/avatarCreate`, avatar);
        // TODO: agregar avatar a lista de avatares??
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    avatarUpdate: async ({}, avatar) => {
      try {
        const response = await Interceptor.put(`${urlAPI}/avatarUpdate`, avatar);
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    avatarDelete: async ({}, avatar) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/avatarDelete`, avatar);
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    editorialCardsSearch: async ({commit}, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/editorialCardsSearch?filter=${params.filter}&pageNumber=${params.pageNumber}`);
        commit("SET_listCards", response.data.data)
        commit("SET_totalCards", response.data.totalResults)
        return response
      } catch (error) {
        console.error(error);
      }
    },
    editorialCardGet: async ({}, params) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/editorialCardGet?id=${params.id}`)
        return response  
      } catch (error) {
        console.error(error)
      }
    },
    editorialCardCreate: async ({}, model) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/editorialCardCreate`, model)
        return response.data
      } catch (error) {
        console.error(error)
      }
    },
    editorialCardUpdate: async ({}, model) => {
      try {
        const response = await Interceptor.put(`${urlAPI}/editorialCardUpdate`, model)
        return response.data
      } catch (error) {
        console.error(error)
      }
    },
    editorialCardPublish: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/editorialCardPublish?id=${params.id}`, {})
        return response
      } catch (error) {
        console.error(error)
      }
    },
    editorialCardUnpublish: async ({}, params) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/editorialCardUnpublish?id=${params.id}`, {})
        return response
      } catch (error) {
        console.error(error)
      }
    },
    getAppUsersQty: async ({}) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/getAppUsersQty`)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    seasonsGet: async({commit}) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/seasonsGet`)
        commit("SET_seasons", response.data)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    seasonCreate: async({}, model) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/seasonCreate`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    seasonUpdate: async({}, model) => {
      try {
        const response = await Interceptor.put(`${urlAPI}/seasonUpdate`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    tutorialGet: async({}) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/tutorialGet`)
        return response.data
      } catch (error) {
        console.error(error)
      }
    },
    tutorialSet: async({}, model) => {
      try {
        const response = await Interceptor.put(`${urlAPI}/tutorialSet`, model)
        return response
      } catch (error) {
        console.error(error)
      }
    },
    bannerGet: async({}) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/bannerGet`)
        return response.data
      } catch (error) {
        console.error(error)
      }
    },
    bannerSet: async({}, model) => {
      try {
        const response = await Interceptor.put(`${urlAPI}/bannerSet`, model)
        return response.data
      } catch (error) {
        console.error(error)
      }
    },
    seasonDelete: async({}, params) => {
      try {
        const response = await Interceptor.delete(`${urlAPI}/seasonDelete?id=${params.id}`)
        return response
      } catch (error) {
        console.error(error)
      }
    }
  },
  mutations: {
    SET_teams(state, value) {
      state.teams = value;
    },
    SET_stadiums(state, value) {
      state.stadiums = value;
    },
    SET_listCards(state, value) {
      state.cards = value;
    },
    SET_totalCards(state, value) {
      state.totalCards = value
    },
    SET_seasons(state, value) {
      state.seasons = value
    }
  },
  getters: {
    getTeamById: state => id => {
      const response = state.teams.find(e => e.id === Number(id));
      return response;
    },
    getStadiumById: state => id => {
      const response = state.stadiums.find(e => e.id === Number(id));
      return response;
    },
    getAvatarById: state => id => {
      const response = state.avatars.find(e => e.id === Number(id));
      return response;
    },
    getSeasonById: state => id => {
      const response = state.seasons.find(e => e.id === Number(id));
      return response;
    }
  }
};

export default Stuff;
